module.exports = __webpack_public_path__ + "static/media/tony.ced3e076.jpg";